import React from 'react';
import './index.css';

import { fullpageApi } from "@fullpage/react-fullpage";
import ScrollDownBtn from "../../components/ScrollDownBtn";
import ScrollUpBtn from "../../components/ScrollUpBtn";
import type { IRoof, IRoofAddress } from "../../react-app-env";
import RoofType from "../../components/RoofType";
import { roofTypesMap } from "../../config/config";

interface P {
	sectionId?: string
	roofIndex?: number
	isLastRoof?: boolean
	onAddRoof?: () => void
	activePageId: string
	i18nMap: any
	fullpageApi: fullpageApi
	errors: Map<string, string>
	selectedDraft: IRoofAddress
	roofDrafts: IRoofAddress[]
	selectRoofType: any
	addDraft: any
	disableFields: boolean
	canAddMoreRoofs: () => boolean
	maxRoofs: number
	onRemoveRoof?: () => void
}

export default (
	{
		sectionId = 'step2',
		roofIndex = 0,
		isLastRoof = true,
		onAddRoof,
		onRemoveRoof,
		activePageId,
		i18nMap,
		fullpageApi,
		errors,
		selectedDraft,
		roofDrafts,
		selectRoofType,
		addDraft,
		disableFields,
		canAddMoreRoofs,
		maxRoofs,
	}: P
) => {

	const isActive: boolean = activePageId === sectionId;

	const getRoof = () => selectedDraft?.roofs?.length > 0 ? selectedDraft.roofs[0] as IRoof : undefined;

	// Only show add button on last roof's type section
	const showAddButton = isLastRoof && !disableFields && selectedDraft.roofType !== roofTypesMap[0].type && canAddMoreRoofs();
	const showMaxRoofsMessage = isLastRoof && !disableFields && selectedDraft.roofType !== roofTypesMap[0].type && !canAddMoreRoofs();

	const handleAddRoof = () => {
		if (onAddRoof) {
			onAddRoof();
		}
	};

	return (
		<div id={sectionId} className={`header header-roof section`}>


			<h2 className="roof-type-heading">

				{ /* i18nMap.whatRoofType */}
			</h2>
			<div className={`outer-step`}>
				<ScrollUpBtn onClick={() => fullpageApi.moveSectionUp()} label={i18nMap.backToAddress} />
				<div className={`sub-step-title`}>
					<div className="sub-step-title-left">
						<span className="roof-icon-label"><i className="fa fa-th-large" />{roofDrafts.length > 1 && <span className="roof-icon-number">{roofIndex + 1}</span>}</span> {i18nMap.roofType}
					</div>
					{roofDrafts.length > 1 && onRemoveRoof && !disableFields && (
						<button className="remove-roof-btn" onClick={onRemoveRoof} title={i18nMap.deleteTab}>
							<span className="remove-roof-label">{i18nMap.removeRoof}</span>
							<span className="remove-icon-text">×</span>
						</button>
					)}
				</div>
				<div className={`inner-step step-2-roof-type`}>

					<RoofType {...{
						selectRoofType,
						i18nMap,
						selectedRoofType: selectedDraft.roofType,
						roof: getRoof(),
						hasError: !!errors.get(`${selectedDraft.id}:right`) && selectedDraft.roofType === roofTypesMap[0].type,
						disableFields,
						isActive,
					}} />
				</div>

				<div className={`add-roof-btn-wrapper ${showAddButton ? 'is-visible' : ''}`}>
					<div className="add-another-roof-btn non-selectable"
						onClick={handleAddRoof}>
						{i18nMap.addAnotherRoof}
					</div>
				</div>

				{showMaxRoofsMessage && (
					<div className="max-roofs-message">
						<i className="fa fa-info-circle"></i>
						<span>{i18nMap.maxRoofsReached}</span>
					</div>
				)}
				<ScrollDownBtn onClick={() => fullpageApi.moveSectionDown()} label={isLastRoof ? i18nMap.nextToTeaser : i18nMap.nextStep} />
			</div>


		</div>
	);
};
